import React, { Component } from "react";
import { Typography, Carousel } from "antd";
const { Title } = Typography;

export default class CarouselModalModuleBVka extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.carousel = React.createRef();
  }
  next() {
    this.carousel.next();
  }
  previous() {
    this.carousel.prev();
  }

  render() {
    const props = {};
    const { onClose } = this.props;
    const onCloseModal = () => this.onClose;
    return (
      <>
        <Carousel ref={(node) => (this.carousel = node)} {...props}>
          <div className="styles-katnh">
            <Title
              level={4}
              style={{
                fontFamily: "Roboto Slab",
                fontSize: "20px",
                textDecoration: "none",
                color: "#1d396e",
                paddingBottom: "20px",
              }}
            >
              U gebruikt een VKA (1/2)
            </Title>

            <img
              src="/client/katnh/small_dots.svg"
              alt="divider"
              style={{ height: "2px" }}
            />
            <ul
              style={{
                marginBottom: "20px",
                fontSize: "15px",
                marginLeft: "1px",
              }}
            >
              <li style={{ listStyleType: "disc", padding: "3px 0" }}>
                U stelt de trombosedienst tijdig op de hoogte, zij begeleiden u
                rondom de ingreep/ operatie
              </li>
              <li style={{ listStyleType: "disc", padding: "3px 0" }}>
                Afhankelijk van het bloedingsrisico van uw ingreep/ operatie
                stopt u tijdelijk met de VKA
              </li>
              <li style={{ listStyleType: "disc", padding: "3px 0" }}>
                Als door het stoppen van de VKA hettrombo-embolie risico te hoog
                is, wordt er overbrugd met heparine spuitjes (Zie LMWH)
              </li>
            </ul>
          </div>
          <div className="styles-katnh">
            <Title
              level={4}
              style={{
                fontFamily: "Roboto Slab",
                fontSize: "20px",
                textDecoration: "none",
                color: "#1d396e",
                paddingBottom: "20px",
              }}
            >
              U gebruikt een VKA (2/2)
            </Title>
            <img
              src="/client/katnh/small_dots.svg"
              alt="divider"
              style={{ height: "2px", marginBottom: "5px" }}
            />
            <ul
              style={{
                marginBottom: "20px",
                fontSize: "15px",
                marginLeft: "1px",
              }}
            >
              <li style={{ listStyleType: "disc", padding: "3px 0" }}>
                De behandelend arts is verantwoordelijk voor het beleid rond uw
                operatie/ingreep en bespreekt dit met u
              </li>
              <li style={{ listStyleType: "disc", padding: "3px 0" }}>
                Uw arts meldt u na uw ingereep/ operatie weer aan bij de
                trombosedienst en bepaalt wanneer u weer start met de VKA
              </li>
            </ul>
          </div>
        </Carousel>
        <div className="button-close" onClick={this.previous}>
          <img
            src="/client/katnh/small_dots.svg"
            alt="divider"
            style={{ height: "2px" }}
          />
          <span
            style={{
              display: "block",
              padding: "0 0 8px 0",
              fontSize: "14px",
            }}
          >
            Vorige
          </span>
          <img
            src="/client/katnh/arrow_blue.svg"
            alt="arrow"
            style={{
              height: "17px",
              marginTop: "5px",
              transform: "rotate(180deg)",
            }}
            className="icon-blue"
          />
          <img
            src="/client/katnh/arrow_white.svg"
            alt="arrow"
            style={{
              height: "17px",
              marginTop: "5px",
              transform: "rotate(180deg)",
            }}
            className="icon-white"
          />
        </div>
        <div className="button-close" onClick={this.next}>
          <img
            src="/client/katnh/small_dots.svg"
            alt="divider"
            style={{ height: "2px" }}
          />
          <span
            style={{
              display: "block",
              padding: "0 0 8px 0",
              fontSize: "14px",
            }}
          >
            Volgende
          </span>
          <img
            src="/client/katnh/arrow_blue.svg"
            alt="arrow"
            style={{ height: "17px", marginTop: "5px" }}
            className="icon-blue"
          />
          <img
            src="/client/katnh/arrow_white.svg"
            alt="arrow"
            style={{ height: "17px", marginTop: "5px" }}
            className="icon-white"
          />
        </div>
      </>
    );
  }
}
